import axios from 'axios';

const state= {
    Items:{
        data:[],
        total:0
    },
    Loadings:{
        list:false,
        create:false
    },
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
};

const actions = {
    getItems({commit},params){
        commit( 'setLoadings', {key:"list",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/address`,{
                params: params
            })
                .then(response => {
                    commit( 'setLoadings', {key:"list",val:false});
                    commit( 'setItems', response.data.data);
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setLoadings', {key:"list",val:false});
                    reject( error )
                });
        });
    },
    createItem({commit},param){
        commit( 'setLoadings', {key:"create",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/order-item`,param)
                .then(response => {
                    commit( 'setLoadings', {key:"create",val:false});
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setLoadings', {key:"create",val:false});
                    reject( error )
                });
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}